import { AddressInput } from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const createFacilityMutationAtom = createMutationAtomFactory(
  'settings.facilityCreate',
  (params: {
    facilityName: string;
    facilityType: string;
    facilityGroupId?: string;
    timezone: string;
    address: AddressInput;
    customAttributes?: Record<string, unknown>;
  }) => ({
    coreFacilityCreate: {
      __args: {
        input: {
          facilityName: params.facilityName,
          facilityType: params.facilityType,
          facilityGroupId: params.facilityGroupId,
          timezone: params.timezone,
          address: params.address,
          customAttributes: params.customAttributes,
        },
      },
      id: true,
    },
  }),
);
